import { useEffect, useState } from 'react';

const NARROW_MAX_WIDTH = 900;

const measure = () => typeof window !== 'undefined' && window.innerWidth < NARROW_MAX_WIDTH;

/** True below the layout's single-column breakpoint. */
export function useIsNarrow() {
  const [isNarrow, setIsNarrow] = useState(measure);

  useEffect(() => {
    const sync = () => setIsNarrow(measure());
    sync();
    window.addEventListener('resize', sync);
    return () => window.removeEventListener('resize', sync);
  }, []);

  return isNarrow;
}
